<ul class="nav nav-pills wizard-tabs" role="tablist">
  <li [class.active]="activeWizardTab === 'Form 8936'">
    <a (click)="onTabSelect('Form 8936')" style="cursor: pointer;" class="btn-sm">Form 8936</a>
  </li>
  <li [class.active]="activeWizardTab === 'Schedule A'">
    <a (click)="onTabSelect('Schedule A')" style="cursor: pointer;" class="btn-sm">Schedule A</a>
  </li>
</ul>

<div class="wizard-tab-hilighter">{{ activeWizardTab }}</div>

@if (activeWizardTab === 'Form 8936') {
<div class="wizard-content">
  <ng-content select="[form8936]"></ng-content>
</div>
}

@if (activeWizardTab === 'Schedule A') {
<div class="wizard-content">
  <gtw-credits-part-iii-f8936-sch-a
    [activeTab]="activeTab"
    [rowData]="rowData"
    [filterParams]="filterParams"
    [globalService]="globalService"
    [generalConfig]="generalConfig"
    [userSettings]="userSettings"
    [formDataObj]="formDataObj"
    (cancel)="onSchACancel()">
  </gtw-credits-part-iii-f8936-sch-a>
</div>
}
